import { Form, Input, Button, message, Select, Empty } from 'antd';
import React, { useRef, useState } from 'react';
import { useMount, useUnmount } from 'ahooks';
import md5 from 'md5';

import userApi from '@/api/userapi';
import messageApi from '@/api/message';
// import { regs } from '@/utils/formValidations';
import config from '@/config';
import { getPhoneAreaList } from '@/utils/commonBiz';

export default function Forget(props) {

  const form = useRef(null);
  const timer = useRef(null);
  const { updateOperate } = props;

  const [sending, setSending] = useState(false);
  const [timing, setTiming] = useState(60);
  const [loading, setLoading] = useState(false);
  const [areaList, setAreaList] = useState([]);

  useMount(() => {
    getPhoneAreaList().then(data => {
      setAreaList(data);
    });
  });

  useUnmount(() => {
    if(timer.current) {
      clearInterval(timer.current);
    }
  });

  const sendMessage = async () => {
    if(sending) return;
    const phone = form.current.getFieldValue('phone');
    const phoneAreaCodeText = form.current.getFieldValue('phoneAreaCodeText') || '';
    const phoneAreaCode = phoneAreaCodeText.split(' ').pop();
    if(!PHONE_REG.test(phone)) return message.error('请输入正确格式手机号');
    await userApi.getByPhone({ phone, phoneAreaCode });
    await messageApi.sendPhone({ phone, phoneAreaCode, version: 2 });
    let timing = 59;
    setSending(true);
    setTiming(timing);
    timer.current = setInterval(() => {
      setTiming(timing--);
      if(timing <= 0) {
        clearInterval(timer.current);
        setSending(false);
      }
    }, 1000);
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const { phone, identifyCode, phoneAreaCodeText } = values;
      const pwd = md5(values.pwd);
      const phoneAreaCode = phoneAreaCodeText.split(' ').pop();
      await userApi.updatePwdByMobile({
        phoneNum: phone,
        phoneAreaCode,
        identifyCode: identifyCode,
        pwd,
        systemCode: config.systemCode,
        version: 2
      });
      message.success('修改成功');
      updateOperate('SIGN');
    } catch(e) {
      setLoading(false);
    }
  };
  return (
    <div className="form-forget">
      <h3 className="form-title">忘记密码</h3>
      <Form ref={form} autoComplete="off" layout="vertical" onFinish={onFinish}>
        <input className="fixed-hide" name="phoneAreaCodeText" />
        <Form.Item
          label="手机号码"
          className="phone-wrap"
        >
          <Input.Group compact>
            <Form.Item
              name="phoneAreaCodeText"
              initialValue="中国 +86"
              rules={[
                { required: true, message: '请选择国家/地区' }
              ]}
            >
              <Select
                options={areaList}
                showSearch
                size="large"
                notFoundContent={<Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  className="ant-empty-small"
                  description="未搜到相关国家/地区码"
                />}
              />
            </Form.Item>
            <Form.Item
              noStyle
              name="phone"
              rules={[
                { required: true, message: '请输入手机号码' },
                { pattern: PHONE_REG, message: '请输入正确的手机号' }
              ]}
            >
              <Input
                className="input-wrap"
                autoComplete="off"
                type="number"
                placeholder="请输入手机号"
              />
            </Form.Item>
          </Input.Group>
        </Form.Item>
        <Form.Item
          label="验证码"
          name="identifyCode"
          rules={[
            { required: true, message: '请输入验证码' }
          ]}
        >
          <Input
            className="dis-flex align-center input-wrap is-code"
            autoComplete="off"
            type="number"
            placeholder="请输入验证码"
            maxLength={4}
            suffix={<Button type="link" onClick={sendMessage}>{sending ? `${timing}秒之后重新获取` : '获取验证码'}</Button>}
          />
        </Form.Item>
        <Form.Item
          label="设置新密码"
          name="pwd"
          style={{ marginBottom: 6 }}
          rules={[
            { required: true, message: '请设置新密码' },
            { min: 6, message: '密码长度不得小于6位' }
          ]}
        >
          <Input.Password className="input-wrap" autoComplete="new-password" placeholder="请设置新密码" visibilityToggle={false} />
        </Form.Item>
        <div className="dis-flex align-center mb20">
          <span className="text-gray">已有账号？</span><Button type="link" onClick={() => updateOperate('SIGN')}>去登录</Button>
        </div>
        <Form.Item className="mb0">
          <Button type="primary" size="large" htmlType="submit" block loading={loading}>登录</Button>
        </Form.Item>
      </Form>
    </div>
  );
}
// 国际手机号
const PHONE_REG = /^[1-9][0-9]{4,15}$/;
